import { createFileRoute } from '@tanstack/react-router';

import { MarketingLandingV2 } from '../features/marketing/landing-v2';

export const Route = createFileRoute('/')({ component: MarketingLandingV2 });
